import FormModalComponent from '72cms-ui/components/helpers/FormModalComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';
import FormModalAddButtonComponent from '72cms-ui/components/table-elements/FormModalAddButtonComponent';
import FormModalEditButtonComponent from '72cms-ui/components/table-elements/FormModalEditButtonComponent';

export default {
    fields: {
        title: {
            label: 'Field label',
        },
        data_type: {
            label: 'Field type',
        },
    },
    sortable: [],
    filterable: [],
    inlineFormComponent: FormModalComponent,
    formConfig: require('./form.panel-form-panel_form_field').default,
    toolbar: [
        {
            label: 'Add new field',
            component: FormModalAddButtonComponent,
        }
    ],
    hideIfEmpty: false,

    pagination: false,
    searchable: false,
    treeView: false,
    batchActions: [
        'active', 'delete',
    ],
    actions: [
        {
            name: 'edit',
            primary: true,
            component: FormModalEditButtonComponent,
        },
        {
            name: 'active',
            primary: true,
            component: ActiveSwitchActionComponent,
        },
        {
            name: 'delete',
            primary: true,
            component: 'delete-button',
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.panel-form-panel_form_fields.js